import { reactive } from 'vue'
import en from '@/translations/en/translations'
import bg from '@/translations/bg/translations'
import al from '@/translations/al/translations'
import hr from '@/translations/hr/translations'
import de from '@/translations/de/translations'
import slo from '@/translations/slo/translations'
import fr from '@/translations/fr/translations'

export const translations = {
  ENG: en,
  BG: bg,
  ALB: al,
  HR: hr,
  GER: de,
  SLO: slo,
  FR: fr
}

export const i18n = reactive({
  locale: localStorage.getItem('language') || 'ENG',
  t: (key) => {
    if (!key) return '';
    const keys = key.split('.')
    
    // Helper to traverse the dictionary
    const getValue = (dict) => {
      // Handle potential default export wrapper from bundlers (Webpack/Vite)
      let val = dict?.default || dict
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return undefined
        }
      }
      return val
    }
    
    // Safely use i18n.locale instead of this.locale to avoid Vue context binding crashes
    let value = getValue(translations[i18n.locale])
    if (value === undefined && i18n.locale !== 'ENG') {
      value = getValue(translations['ENG'])
    }
    
    return value !== undefined ? value : key
  }
})